module.exports = __webpack_public_path__ + "img/landing-video-poster.dcbb6fff.jpg";